"use strict";

var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || Object.assign || function (t) {
  for (var s, i = 1, n = arguments.length; i < n; i++) {
    s = arguments[i];

    for (var p in s) {
      if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
  }

  return t;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var colors_1 = require("@headspace/hs-web-style-guide/dist/colors");

var hs_web_style_guide_1 = require("@headspace/hs-web-style-guide");

var text_1 = require("../text");

var flex = require('@headspace/hs-web-style-guide/dist/flex').default;

var spacing = require('@headspace/hs-web-style-guide/dist/spacing').default;

var panelStyles = hs_web_style_guide_1.css({
  border: "1px solid " + colors_1.carrarra,
  backgroundColor: 'white',
  borderRadius: 4,
  boxShadow: "0 2px 0 " + colors_1.rgba(colors_1.black, 0.04)
});
var actionStyles = hs_web_style_guide_1.css(spacing.marginLeftSmaller, {
  border: 'none',
  backgroundColor: 'none',
  textDecoration: 'none',
  color: colors_1.jaffa,
  ':hover': {
    color: colors_1.tango
  },
  padding: 0,
  ':focus': {
    outline: 0
  }
});
var actionsWrapperStyles = hs_web_style_guide_1.css({
  '& a, & button': actionStyles
});

var Panel =
/** @class */
function (_super) {
  __extends(Panel, _super);

  function Panel() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  Panel.prototype.render = function () {
    var _a = this.props,
        title = _a.title,
        _b = _a.actions,
        actions = _b === void 0 ? [] : _b,
        children = _a.children,
        otherProps = __rest(_a, ["title", "actions", "children"]);

    var space = spacing[this.props.spacing || ''] || {};
    return React.createElement("div", __assign({}, panelStyles, space, otherProps), (title || actions.length > 0) && React.createElement("div", __assign({}, flex.flex, flex.row, flex.justifyContentSpaceBetween, flex.alignItemsCenter, spacing.paddingTopSmall, spacing.paddingBottomSmall), title && React.createElement(text_1.TitleXS, null, title), actions.length > 0 && React.createElement("div", __assign({}, actionsWrapperStyles), actions.map(function (action, index) {
      return React.createElement(React.Fragment, {
        key: index
      }, action);
    }))), children);
  };

  return Panel;
}(React.Component);

exports.Panel = Panel;